import { CurrentOrgSvc } from "backend/aaa/CurrentOrgSvc"
import { IBoardData } from "shared/entities/projects/IBoardData"

export const listBoardsFun = (): Promise<firebase.firestore.QuerySnapshot<IBoardData>> => {
    return CurrentOrgSvc.currentOrg.snapshot.ref
        .collection("Boards")
        .where("deleted", "==", false)
        .get() as Promise<firebase.firestore.QuerySnapshot<IBoardData>>
}